import styled, { css, keyframes } from "styled-components";

const borderResize = keyframes`
  from {
    border-width: 5px;
  }
  to {
    border-width: 3px;
  }
`;

export const MainTitle = styled.h1`
  font-size: 1.5rem;
  font-weight: bold;
  margin: 0;
`;

export const TemplateWrapper = styled.div`
  aspect-ratio: ${({ aspectRatio }) => aspectRatio};
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  border-radius: 12px;
  transition: border-color 0.2s;
  border: 3px solid ${({ isTemplateSelected }) => (isTemplateSelected ? "#36F99F" : "transparent")};

  ${({ isTemplateSelected }) =>
    isTemplateSelected &&
    css`
      animation: ${borderResize} 0.2s forwards;
    `}

  > div img {
    border-radius: 12px;
  }

  > button {
    visibility: hidden;
  }

  &:hover {
    > button {
      visibility: visible;
    }
  }
`;

export const PreviewAreaWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 50px;
  padding-bottom: 50px;
`;

export const CheckSelectorWrapper = styled.div`
  position: absolute;
  top: 10px;
  right: 10px;
  z-index: 1;
  text-shadow: 1px 1px black;
  cursor: pointer;
  & > svg {
    width: 30px;
    height: 30px;
  }
`;

export const ChannelSelectors = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1px;

  img {
    width: 25px;
    height: 25px;
  }
`;

export const Checkbox = styled.label`
  white-space: nowrap;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 4px;
  border-radius: 4px;
  justify-content: center;
  padding: 7px 10px;
  cursor: pointer;
  border: 1px solid #7a89f4;
  background-color: transparent;

  ${({ checked }) =>
    checked &&
    css`
      border: 1px solid #dce0fc;
      background-color: #dce0fc;
    `}

  ${({ isPostBox }) =>
    isPostBox &&
    css`
      font-size: 12px;
      width: 100%;
      border: 1px solid #dce0fc;
      padding: 4px 8px;
    `}

  ${({ isValid }) =>
    !isValid &&
    css`
      cursor: not-allowed;
      pointer-events: none;
      opacity: 0.5;
    `}
`;
